<template>
  <div class="qta_wrapper">
    <div>해설</div>
    <NormalEditor
      key="ned_2"
      ref="editor77"
      :content="qcomment"
      func="updateQReadingComment"
    />

    <b-row>
      <b-col>선택지*</b-col>
    </b-row>

    <div :class="qtype8_valid_cls">
      <b-row :key="pick.id" v-for="pick in picks">
        <b-col sm="4" lg="4" offset="1">
          <!-- <BogiEditor :content="pick.text" :func="pick.myf1" /> -->
          <b-input size="sm" v-model="pick.text" placeholder="정답제목" />
        </b-col>
        <b-col sm="4" lg="4">
          <BogiEditor :content="pick.answer" :func="pick.myf2" />
        </b-col>

        <b-col lg="2" sm="2">
          <b-button
            class="float-left"
            size="sm"
            variant="danger"
            @click="removePick(pick)"
            >D</b-button
          >
        </b-col>
      </b-row>
    </div>

    <b-row :class="nocount_qtype8_valid_cls">
      <b-col>
        <b-form-group>
          <b-button block size="sm" @click="appendPick()">
            정답 추가(+)
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-select
          id="select-question-point"
          v-model="point"
          :options="question_point_options"
        />
      </b-col>
    </b-row>
    <ReadingIntent :key="1000" intentName="intent1" updatenm="updateIntent1" />
    <ReadingIntent :key="1001" intentName="intent2" updatenm="updateIntent2" />
    <ReadingIntent :key="1002" intentName="intent3" updatenm="updateIntent3" />
  </div>
</template>

<script>
import BogiEditor from "@/components/BogiEditor";
import NormalEditor from "@/components/NormalEditor";
import ReadingIntent from "@/components/question/ReadingIntent2";
export default {
  watch: {
    id(to, from) {
      if (to === "" || to == null) {
        this.$refs.editor77.reset();
      }
    },
  },

  components: { BogiEditor, ReadingIntent, NormalEditor },
  computed: {
    id() {
      return this.$store.state.questionform.id;
    },

    qcomment() {
      return this.$store.state.questionform.qcomment_imsi;
    },

    picks() {
      return this.$store.state.qtype8_picks;
    },
    point: {
      get() {
        return this.$store.state.questionform.point;
      },
      set(val) {
        // this.$store.state.questionform.point
        this.$store.commit("updatePoint", val);
      },
    },
    question_point_options() {
      return this.$store.state.question_point_options;
    },
    nocount_qtype8_valid_cls() {
      return this.$store.state.valid.qtype8_nocount;
    },

    qtype8_valid_cls() {
      return this.$store.state.valid.qtype8;
    },
  },
  methods: {
    appendPick() {
      this.$store.dispatch("appendQType8Pick", "");
    },
    removePick(pick) {
      if (confirm("삭제하시겠습니까?")) {
        this.$store.dispatch("removeQType8Pick", pick);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.qta_wrapper {
  margin-bottom: 15px;
  .multisel_wrapper {
    margin-top: 5px;
  }
  .badgecls {
    padding: 6px;
    margin-bottom: 2px;
  }
  div {
    margin-bottom: 2px;
  }
}
</style>